import { render, staticRenderFns } from "./PriceCheckerView.vue?vue&type=template&id=4abdb743"
import script from "./PriceCheckerView.vue?vue&type=script&lang=js"
export * from "./PriceCheckerView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports